module.exports = __webpack_public_path__ + "cbe1b676.svg";